import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail, Instagram } from "lucide-react";
import { BUSINESS } from "../lib/api";
import { RFMonogram } from "./RFMonogram";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 bg-emerald-950 text-emerald-100 relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #10b981 0, transparent 40%), radial-gradient(circle at 80% 80%, #10b981 0, transparent 45%)" }} />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl overflow-hidden ring-1 ring-emerald-500/30 shadow-lg shadow-emerald-950/40">
              <img
                src={BUSINESS.logoUrl}
                alt="Sixty Finance"
                width="112"
                height="112"
                loading="lazy"
                className="h-full w-full object-cover"
                style={{ imageRendering: "-webkit-optimize-contrast" }}
              />
            </span>
            <div className="flex flex-col leading-tight">
              <span className="text-white text-lg font-semibold tracking-tight">
                Sixty Finance
              </span>
              <span className="text-xs text-emerald-300 italic">
                Always by your side
              </span>
            </div>
          </div>
          <p className="text-sm text-emerald-200/80 leading-relaxed max-w-xs">
            An Australia-wide broking firm helping Australians find the right
            loan — with real people, honest advice, and quick answers.
          </p>
          <a
            href="https://www.instagram.com/sixtyfinanceptyltd/?hl=en"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="mt-5 inline-flex items-center gap-2 text-sm text-emerald-200 hover:text-white transition-colors"
          >
            <Instagram className="h-4 w-4" /> Instagram
          </a>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
            Services
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services#home-loans" className="hover:text-white">Home Loans</Link></li>
            <li><Link to="/services#car-loans" className="hover:text-white">Car & Asset Finance</Link></li>
            <li><Link to="/services#personal-loans" className="hover:text-white">Personal Loans</Link></li>
            <li><Link to="/services#business-loans" className="hover:text-white">Business & Commercial</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
            Company
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/team" className="hover:text-white">Meet the Team</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/quote" className="hover:text-white">Get a Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
            Get in touch
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-emerald-400" />
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-phone-link"
                className="num hover:text-white"
              >
                {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-emerald-400" />
              <a href={`mailto:${BUSINESS.email}`} className="hover:text-white">
                {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-emerald-400" />
              <span>{BUSINESS.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-emerald-400" />
              <span>{BUSINESS.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-emerald-900/60">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-emerald-300/70">
          <p>© {new Date().getFullYear()} Sixty Finance. All rights reserved.</p>
          <p className="max-w-xl">
            Your full financial situation will need to be reviewed prior to
            acceptance of any offer or product. Credit representative details
            available on request.
            <RFMonogram className="ml-2 h-6 w-6 opacity-45 hover:opacity-80 transition-opacity duration-300" />
          </p>
        </div>
      </div>
    </footer>
  );
};
